import { useMutation } from '@tanstack/react-query'

import {
  createConversation,
  deleteConversation,
  updateConversation,
} from './api'

import type { UseMutationOptions } from '@tanstack/react-query'

import type {
  CreateConversationResponse,
  DeleteConversationArguments,
  DeleteConversationResponse,
  UpdateConversationArguments,
  UpdateConversationResponse,
} from './types'

export const useCreateConversationMutation = ({
  onError,
  onSuccess,
}: {
  onError: () => void
  onSuccess: (data: CreateConversationResponse['conversation']) => void
}) => useMutation({ mutationFn: createConversation, onError, onSuccess })

export const useUpdateConversationMutation = (
  options?: UseMutationOptions<
    UpdateConversationResponse,
    Error,
    UpdateConversationArguments
  >,
) => useMutation({ mutationFn: updateConversation, ...options })

export const useDeleteConversationMutation = (
  options?: UseMutationOptions<
    DeleteConversationResponse,
    Error,
    DeleteConversationArguments
  >,
) => useMutation({ mutationFn: deleteConversation, ...options })
